export default {
  baseMargin: '1rem',
  doubleBaseMargin: '2rem'
}
